<template>
<div class="news-template-wrap">
    <div v-for="(item,index) in listData" :key="index" class="news-template" >
        <div class="template-left" @click="$router.push(`/newsDetails/${item.id}`)">
            <img :src="item.photo" alt="">
        </div>
        <div class="template-right">
            <h2 @click="$router.push(`/newsDetails/${item.id}`)">{{item.name}}</h2>
            <span class="subtitle" @click="$router.push(`/newsDetails/${item.id}`)">{{item.remark}}</span>
            <div class="collection-icon">
                <span class="timer">{{item.time}}</span>
                <div class="icon">
                    <!--<span class="img-dz" @click="dianzan(item.id)"><img src="../../static/image/new_sc.png" alt=""></span>
                     <span class="img-zf" @click="zhuanfa(item.photo,item.name)">
                        <img src="../../static/image/zhuanfa.png" alt="">
                    </span> -->
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>

export default {
    name: "NewsTemplate",
    props: ['listData'],
    methods:{
        
        async dianzan(id){
            const uid = window.localStorage.getItem('uid')
           let result = await this.$http.signUp.doUserToNewsLike({
                news_id:id,
                uid:uid
            })
            if(result.code == 200){
                this.$message({
                    message: '点赞成功！',
                    type: 'warning',
                    center: true,
                    offset: 140
                })
            }
        }
    }
}
</script>

<style lang="less">
.news-template {
    width: 100%;
    height: 240px;
    display: flex;
    border-bottom: 1px dashed #e1e1e1;
    padding-bottom: 20px;
    padding-top: 20px;

    .template-left {
        width: 38%;
        margin-right: 20px;

        img {
            width: 100%;
            height: 100%;
            // object-fit: cover
        }
    }

    .template-right {
        cursor: pointer;
        width: 60%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        h2 {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: normal;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
            margin-bottom: 10px;
            color: #404040;
        }

        .subtitle {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: normal;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 3;
            line-height: 32px;
            font-size: 28px;
        }

        .collection-icon {
            padding-right:20px;
            display: flex;
            // margin-top: 20px;
            justify-content: space-between;
            vertical-align: middle;

            img {
                margin-left: 20px;
                display: inline-block;
                

            }
            .img-zf{
                img{
                    width:44px;
                    height: 44px;

                }
            }
        }
    }
}
</style>
